import { render, staticRenderFns } from "./card-end-conversation.vue?vue&type=template&id=b4b6eeca&scoped=true"
import script from "./card-end-conversation.vue?vue&type=script&lang=js"
export * from "./card-end-conversation.vue?vue&type=script&lang=js"
import style0 from "./card-end-conversation.vue?vue&type=style&index=0&id=b4b6eeca&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b6eeca",
  null
  
)

export default component.exports